import MetaOption from './MetaOption';

// This is the same as an option for now, so just make it one of them.
class MetaOperator extends MetaOption {
  constructor(args) {
    super(args);
  }

  // merge() handled automatically
}

export default MetaOperator;
